import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b619f48"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row w-75 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-3 d-flex justify-content-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mr-4 symbol symbol-circle" }, [
        /*#__PURE__*/_createElementVNode("span", { class: "symbol-label btn-icon-white background_layout_1" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info fs-2x text-white" })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-9 d-flex" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "card-title d-flex align-items-start flex-column" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "card-label fw-bolder fs-4 mb-1" }, "Informações do agendamento")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "row mt-3 px-3" }
const _hoisted_6 = { class: "col-6 px-3" }
const _hoisted_7 = {
  style: {"background-color":"#F5F7FA","border-radius":"8px"},
  class: "lh-1 px-3 py-3"
}
const _hoisted_8 = {
  key: 0,
  class: "text-muted mt-1 mb-0 fs-7 fw-light"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "text-muted mt-1 mb-1 fs-7 fw-light"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 2,
  class: "text-muted mt-1 mb-1 fs-7 fw-light"
}
const _hoisted_13 = {
  key: 3,
  class: "text-muted mt-1 mb-1 fs-7 fw-light"
}
const _hoisted_14 = {
  key: 4,
  class: "text-muted mt-1 mb-1 fs-7 fw-bold pointer d-flex"
}
const _hoisted_15 = {
  key: 0,
  class: "ms-3"
}
const _hoisted_16 = {
  key: 1,
  class: "ms-3"
}
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "d-flex justify-content-end mb-5" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "d-flex justify-content-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-white" }),
  /*#__PURE__*/_createTextVNode("Adicionar Mais Serviço")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Aguarde... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "modal-body pb-5" }
const _hoisted_25 = {
  key: 0,
  class: "row"
}
const _hoisted_26 = { class: "col" }
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Status da Tarefa", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Tipo de tarefa", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_35 = { class: "col" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Técnico responsável", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Data final da tarefa", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_43 = {
  key: 2,
  class: "row"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Horário inicial ", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_46 = { class: "col d-flex flex-column" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, " Horário final ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_49 = {
  key: 0,
  class: "col-4"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, " Horário entrega ", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1))
const _hoisted_52 = {
  key: 3,
  class: "d-flex justify-content-end mt-n4 mb-4"
}
const _hoisted_53 = ["data-kt-indicator"]
const _hoisted_54 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_55 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_56 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_58 = {
  key: 4,
  class: "row mb-9"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-4 mt-6" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tempo adicional")
], -1))
const _hoisted_60 = { class: "d-flex justify-content-around" }
const _hoisted_61 = { class: "indicator-label" }
const _hoisted_62 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_63 = {
  key: 0,
  class: "indicator-progress"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_65 = { class: "indicator-label" }
const _hoisted_66 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_67 = {
  key: 0,
  class: "indicator-progress"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_69 = { class: "indicator-label" }
const _hoisted_70 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_71 = {
  key: 0,
  class: "indicator-progress"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_73 = { class: "indicator-label" }
const _hoisted_74 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_75 = {
  key: 0,
  class: "indicator-progress"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_77 = { class: "indicator-label" }
const _hoisted_78 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_79 = {
  key: 0,
  class: "indicator-progress"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_81 = { class: "indicator-label" }
const _hoisted_82 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_83 = {
  key: 0,
  class: "indicator-progress"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_85 = {
  key: 5,
  class: "modal-footer d-flex justify-content-between pb-0 px-0"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z",
        fill: "#000000",
        "fill-rule": "nonzero"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z",
        fill: "#000000",
        opacity: "0.3"
      })
    ])
  ])
], -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C16.9705627,4 21,8.02943725 21,13 C21,17.9705627 16.9705627,22 12,22 Z",
        fill: "#000000",
        opacity: "0.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z",
        fill: "#000000"
      })
    ])
  ])
], -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-thumbs-up" })
], -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" })
], -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 cor_btn_1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-times" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusChecklist = _resolveComponent("StatusChecklist")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AdicionarServicoModal = _resolveComponent("AdicionarServicoModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade show",
    id: `kt_modal_event_edit_info_${_ctx.id}`,
    "aria-modal": "true",
    role: "dialog",
    ref: "newTargetModalRef"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_modal_add_event_form",
          onSubmit: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.targetData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.targetData.codTipoServico < 9)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_ctx.targetData.cliente) + " - " + _toDisplayString(_ctx.targetData.placa ? _ctx.targetData.placa : _ctx.targetData.chassi), 1),
                        (_ctx.targetData.modelo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, " - " + _toDisplayString(_ctx.targetData.modelo), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.codTipoServico != 10 && _ctx.targetData.codTipoServico != 11)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_ctx.targetData.taskDateTratada), 1),
                        (_ctx.targetData.codTipoServico < 9 && _ctx.targetData.taskHourRecepcao != '00:00')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" - Recepção: " + _toDisplayString(_ctx.targetData.taskHourRecepcao), 1),
                              (_ctx.targetData.taskHourEntrega != '00:00')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, " - Entrega: " + _toDisplayString(_ctx.targetData.taskHourEntrega), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.codTipoServico < 9 && _ctx.targetData.consultorAgendado)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Consultor: " + _toDisplayString(_ctx.targetData.consultorAgendadoTratado), 1))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.osAberta)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Ordem de Serviço (OS): " + _toDisplayString(_ctx.targetData.osAberta), 1))
                    : _createCommentVNode("", true),
                  (_ctx.targetData.statusName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createTextVNode(" Status: " + _toDisplayString(_ctx.targetData.statusName) + " ", 1),
                        (_ctx.targetData.taskStartExecucao)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Início execução: " + _toDisplayString(_ctx.targetData.taskStartExecucao), 1))
                          : _createCommentVNode("", true),
                        (_ctx.targetData.taskEndExecucao)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Fim execução: " + _toDisplayString(_ctx.targetData.taskEndExecucao), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.targetData.dadosChecklist)
                    ? (_openBlock(), _createBlock(_component_StatusChecklist, {
                        key: 0,
                        statusCor: _ctx.targetData.dadosChecklist?.setorCor,
                        setor: _ctx.targetData.dadosChecklist?.setor
                      }, null, 8, ["statusCor", "setor"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.configSchedule?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newTask())),
                          type: "button",
                          class: "btn btn-sm background_btn_1 text-white",
                          "data-kt-indicator": "off",
                          id: "kt_button_1"
                        }, _hoisted_23)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.targetData.codTipoServico < 9 && _ctx.targetData.detalhes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("p", null, "Observações: " + _toDisplayString(_ctx.targetData.detalhes), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.configSchedule?.activeBolsao)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_component_el_form_item, { prop: "taskType" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.targetData.statusBolsao,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.statusBolsao) = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.verifyChanges())),
                            placeholder: "Selecione"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusServico, (tipo, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tipo.status,
                                  value: tipo.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _hoisted_30
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_el_form_item, { prop: "taskType" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        disabled: !_ctx.programaAgenda,
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.verifyChanges())),
                        modelValue: _ctx.targetData.codTipoServico,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetData.codTipoServico) = $event)),
                        "value-key": "TIPO",
                        filterable: "",
                        clearable: false,
                        placeholder: "Selecione",
                        "no-match-text": "Nenhum tipo foi encontrado",
                        "no-data-text": "Nenhum tipo foi encontrado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipoOptions, (tipo, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: tipo.text,
                              value: tipo.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["disabled", "modelValue"]),
                      _hoisted_34
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_el_form_item, { prop: "tecnico" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        disabled: !_ctx.programaAgenda,
                        onChange: _cache[5] || (_cache[5] = ($event: any) => {_ctx.verifyChanges(); _ctx.desabilitaHorariosOcupados()}),
                        modelValue: _ctx.targetData.codTecnico,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.targetData.codTecnico) = $event)),
                        "value-key": "TECNICO",
                        filterable: "",
                        clearable: false,
                        placeholder: "Selecione",
                        "no-match-text": "Nenhum técnico foi encontrado",
                        "no-data-text": "Nenhum técnico foi encontrado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tecnicoOptions, (tipo, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: tipo.text,
                              value: tipo.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["disabled", "modelValue"]),
                      _hoisted_37
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.usaChecklist == '147' ? 'col-6' : 'col-12')
                }, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.usaChecklist == '147' ? 'Data inicial da tarefa' : 'Data da tarefa'), 1),
                  _createVNode(_component_el_form_item, { prop: "taskDate" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            disabled: !_ctx.programaAgenda,
                            onChange: _cache[7] || (_cache[7] = ($event: any) => {_ctx.verifyChanges(); _ctx.verificaHorariosOcupados()}),
                            modelValue: _ctx.targetData.taskDate,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.targetData.taskDate) = $event)),
                            type: "text",
                            name: "eventStartDate",
                            format: "DD/MM/YYYY",
                            clearable: false,
                            "disabled-date": _ctx.desabilitaDatasPassadas
                          }, null, 8, ["disabled", "modelValue", "disabled-date"])
                        ]),
                        _: 1
                      }, 8, ["locale"]),
                      _hoisted_40
                    ]),
                    _: 1
                  })
                ], 2),
                (_ctx.usaChecklist == '147')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_ctx.usaChecklist == '147' ? 'col-6' : 'col-12')
                    }, [
                      _hoisted_41,
                      _createVNode(_component_el_form_item, { prop: "taskDate" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                disabled: !_ctx.programaAgenda,
                                onChange: _cache[9] || (_cache[9] = ($event: any) => {_ctx.verifyChanges(); _ctx.verificaHorariosOcupados()}),
                                modelValue: _ctx.targetData.taskEndDate,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.targetData.taskEndDate) = $event)),
                                type: "text",
                                name: "eventStartDate",
                                format: "DD/MM/YYYY",
                                clearable: false,
                                "disabled-date": _ctx.desabilitaDatasPassadas
                              }, null, 8, ["disabled", "modelValue", "disabled-date"])
                            ]),
                            _: 1
                          }, 8, ["locale"]),
                          _hoisted_42
                        ]),
                        _: 1
                      })
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.targetData.codTipoServico != 10 && _ctx.targetData.codTipoServico != 11)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.configSchedule?.name ? 'col-4' : 'col-6')
                    }, [
                      _createVNode(_component_el_form_item, { prop: "taskStartHour" }, {
                        default: _withCtx(() => [
                          _hoisted_44,
                          _createVNode(_component_el_select, {
                            disabled: !_ctx.programaAgenda,
                            modelValue: _ctx.targetData.taskStartHour,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.targetData.taskStartHour) = $event)),
                            "value-key": "HORAINICIAL",
                            filterable: "",
                            clearable: false,
                            placeholder: "Horário inicial",
                            onChange: _cache[12] || (_cache[12] = ($event: any) => {_ctx.desabilitaHorariosOcupados(); _ctx.verifyChanges()})
                          }, {
                            empty: _withCtx(() => []),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultInitialTimes, (time, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: time.text,
                                  value: time.value,
                                  disabled: time.disabled
                                }, null, 8, ["label", "value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"]),
                          _hoisted_45
                        ]),
                        _: 1
                      })
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.configSchedule?.name ? 'col-4' : 'col-6')
                    }, [
                      _createVNode(_component_el_form_item, { prop: "taskEndHour" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_46, [
                            _hoisted_47,
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.targetData.taskEndHour,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.targetData.taskEndHour) = $event)),
                              "value-key": "HORAFINAL",
                              filterable: "",
                              clearable: false,
                              placeholder: "Horário final",
                              disabled: !_ctx.targetData.taskStartHour || !_ctx.programaAgenda,
                              onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.verifyChanges()))
                            }, {
                              empty: _withCtx(() => []),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultFinalTimes, (time, i) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: i,
                                    label: time.text,
                                    value: time.value,
                                    disabled: time.disabled
                                  }, null, 8, ["label", "value", "disabled"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ]),
                          _hoisted_48
                        ]),
                        _: 1
                      })
                    ], 2),
                    (_ctx.configSchedule?.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createVNode(_component_el_form_item, { prop: "taskHourEntrega" }, {
                            default: _withCtx(() => [
                              _hoisted_50,
                              _createVNode(_component_el_time_select, {
                                disabled: !_ctx.targetData.taskEndHour || !_ctx.programaAgenda,
                                modelValue: _ctx.targetData.taskHourEntrega,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.targetData.taskHourEntrega) = $event)),
                                start: _ctx.targetData.taskEndHour,
                                step: "00:15",
                                end: "19:00",
                                placeholder: "Horário entrega"
                              }, null, 8, ["disabled", "modelValue", "start"]),
                              _hoisted_51
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.changesServiceInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("button", {
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      class: _normalizeClass(["btn btn-sm btn-flex background_btn_1_opct text-white", {'disabled': _ctx.loading}]),
                      type: "submit"
                    }, [
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                            _createTextVNode(" Salvar alterações "),
                            _createElementVNode("span", _hoisted_55, [
                              _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                            _createTextVNode(" Salvando alterações... "),
                            _hoisted_57
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_53)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.configSchedule?.additionalTime && ( _ctx.targetData.status == 2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm btn-flex me-2 px-2", {
                    'btn-selected': !_ctx.targetData.tempoAdicionalSelected,
                    'btn-outline-primary' : _ctx.targetData.tempoAdicionalSelected,
                    'disabled': !_ctx.editable
                  }]),
                        onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.targetData.tempoAdicionalSelected = 0; _ctx.confirmaTempoAdicional()}),
                        type: "button"
                      }, [
                        _createElementVNode("span", _hoisted_61, [
                          _createTextVNode(" Sem tempo adicional "),
                          _createElementVNode("span", _hoisted_62, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                              _createTextVNode(" Adicionando tarefa... "),
                              _hoisted_64
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm btn-flex me-2 px-2", {
                    'btn-selected': _ctx.targetData.tempoAdicionalSelected == 15,
                    'btn-outline-primary' : _ctx.targetData.tempoAdicionalSelected != 15,
                    'disabled': !_ctx.editable
                  }]),
                        onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.targetData.tempoAdicionalSelected = 15; _ctx.confirmaTempoAdicional()}),
                        type: "button"
                      }, [
                        _createElementVNode("span", _hoisted_65, [
                          _createTextVNode(" +15 min "),
                          _createElementVNode("span", _hoisted_66, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                              _createTextVNode(" Adicionando tarefa... "),
                              _hoisted_68
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm btn-flex me-2 px-2", {
                    'btn-selected': _ctx.targetData.tempoAdicionalSelected == 30,
                    'btn-outline-primary' : _ctx.targetData.tempoAdicionalSelected != 30,
                    'disabled': !_ctx.editable
                  }]),
                        onClick: _cache[18] || (_cache[18] = ($event: any) => {_ctx.targetData.tempoAdicionalSelected = 30; _ctx.confirmaTempoAdicional()}),
                        type: "button"
                      }, [
                        _createElementVNode("span", _hoisted_69, [
                          _createTextVNode(" +30 min "),
                          _createElementVNode("span", _hoisted_70, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                              _createTextVNode(" Adicionando tarefa... "),
                              _hoisted_72
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm btn-flex me-2 px-2", {
                    'btn-selected': _ctx.targetData.tempoAdicionalSelected == 45,
                    'btn-outline-primary' : _ctx.targetData.tempoAdicionalSelected != 45,
                    'disabled': !_ctx.editable
                  }]),
                        onClick: _cache[19] || (_cache[19] = ($event: any) => {_ctx.targetData.tempoAdicionalSelected = 45; _ctx.confirmaTempoAdicional()}),
                        type: "button"
                      }, [
                        _createElementVNode("span", _hoisted_73, [
                          _createTextVNode(" +45 min "),
                          _createElementVNode("span", _hoisted_74, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                              _createTextVNode(" Adicionando tarefa... "),
                              _hoisted_76
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm btn-flex px-2 me-2", {
                    'btn-selected': _ctx.targetData.tempoAdicionalSelected == 60,
                    'btn-outline-primary' : _ctx.targetData.tempoAdicionalSelected != 60,
                    'disabled': !_ctx.editable
                  }]),
                        onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.targetData.tempoAdicionalSelected = 60; _ctx.confirmaTempoAdicional()}),
                        type: "button"
                      }, [
                        _createElementVNode("span", _hoisted_77, [
                          _createTextVNode(" +60 min "),
                          _createElementVNode("span", _hoisted_78, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                              _createTextVNode(" Adicionando tarefa... "),
                              _hoisted_80
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm btn-flex px-2", {
                    'btn-selected': _ctx.targetData.tempoAdicionalSelected == 120,
                    'btn-outline-primary' : _ctx.targetData.tempoAdicionalSelected != 120,
                    'disabled': !_ctx.editable
                  }]),
                        onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.targetData.tempoAdicionalSelected = 120; _ctx.confirmaTempoAdicional()}),
                        type: "button"
                      }, [
                        _createElementVNode("span", _hoisted_81, [
                          _createTextVNode(" +120 min "),
                          _createElementVNode("span", _hoisted_82, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_83, [
                              _createTextVNode(" Adicionando tarefa... "),
                              _hoisted_84
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showStatusControl || _ctx.editable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                    (_ctx.showStatusControl && (_ctx.targetData.status == 1 || _ctx.targetData.status == 5) && _ctx.targetData.codTipoServico < 9)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex ms-4", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.iniciarServico())),
                          type: "button"
                        }, [
                          _hoisted_86,
                          _createTextVNode(" Iniciar serviço ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.deletarEvento())),
                          type: "button"
                        }, [
                          _hoisted_87,
                          _createTextVNode(" Excluir ")
                        ], 2))
                      : _createCommentVNode("", true),
                    ((_ctx.showStatusControl || (_ctx.editable && _ctx.showEntregaControl)) && _ctx.targetData.codTipoServico < 9 && _ctx.targetData.status != 1 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1 && _ctx.configSchedule?.name))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct btn-flex btn-outline border_btn_1 cor_btn_1", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.cancelarServico())),
                          type: "button"
                        }, [
                          _hoisted_88,
                          _createTextVNode(" Voltar para planejamento ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.showStatusControl && _ctx.targetData.codTipoServico < 9 && _ctx.modeloAgendaName == 'CampV1' && _ctx.targetData.status == 2)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex ms-4", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.paralisarServico())),
                          type: "button"
                        }, [
                          _hoisted_89,
                          _createTextVNode(" Paralisar serviço ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.showStatusControl && _ctx.targetData.status == 2 && _ctx.targetData.codTipoServico < 9 && _ctx.hidenButtonDms.includes(_ctx.dms)  && _ctx.aberturaOS == 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 4,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex ms-4", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.finalizarServico())),
                          type: "button"
                        }, [
                          _hoisted_90,
                          _createTextVNode(" Encerrar serviço ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.showEntregaControl && _ctx.targetData.status == 3 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1 && _ctx.configSchedule?.name))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.ativarControleQualidade())),
                          type: "button"
                        }, [
                          _hoisted_91,
                          _createTextVNode(" Liberado no controle de qualidade ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.showEntregaControl && _ctx.targetData.status == 6 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1 && _ctx.configSchedule?.name))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 6,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.cancelaControleQualidade())),
                          type: "button"
                        }, [
                          _hoisted_92,
                          _createTextVNode(" Cancelar controle de qualidade ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.showEntregaControl && _ctx.targetData.status == 6 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1 && _ctx.configSchedule?.name))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 7,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.entregaAoClienteRealizada())),
                          type: "button"
                        }, [
                          _hoisted_93,
                          _createTextVNode(" Entregue ao cliente ")
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.showEntregaControl && _ctx.targetData.status == 4 && !(_ctx.hidenButtonDms.includes(_ctx.dms) && _ctx.aberturaOS == 1 && _ctx.configSchedule?.name))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 8,
                          class: _normalizeClass(["btn btn-sm background_btn_1_opct text-white btn-flex", {'disabled': _ctx.loadingBtn}]),
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.cancelarEntregaAoClienteRealizada())),
                          type: "button"
                        }, [
                          _hoisted_94,
                          _createTextVNode(" Cancelar entrega ao cliente ")
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _createVNode(_component_AdicionarServicoModal, {
      id: "adicionar-servico",
      initialForm: _ctx.newTaskData,
      onSuccess: _cache[32] || (_cache[32] = ($event: any) => (_ctx.emiteSuccess()))
    }, null, 8, ["initialForm"])
  ], 8, _hoisted_1))
}